/**
 * Mapped tokens are what upcoming Figma components should read.
 * Role colors go through alias. Primitive ramps stay on brand, because
 * screens bind those variables directly. No component tokens yet.
 */

import { brandColors } from './brand';
import { aliasColors, aliasSpace, aliasTextStrings } from './alias';

export const mapped = {
  color: {
    background: aliasColors.background,
    divider: aliasColors.divider,
    neutrals: brandColors.neutrals,
    primary: brandColors.primary,
    secondary: brandColors.secondary,
    tertiary: brandColors.tertiary,
    accents: brandColors.accents,
    semantic: brandColors.semantic,
  },
  space: aliasSpace,
  textStrings: aliasTextStrings,
};
